module.exports = __webpack_public_path__ + "static/media/magfield.b2901c94.png";